@import '../../styles/buttons.css';
@import '../../styles/skeleton.css';

tambr-account-wallet {
  display: block;
  position: relative;
  min-height: 100%;
}

.credit-wrapper {
  margin: 15px 0 30px;
}

.payment-methods-wrapper {
  margin-top: 15px;
}

.payment-methods-title, .credit-title {
  font-size: 12px;
  padding: 12px 15px 20px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #666;
  border-bottom: 1px solid rgba(0,0,0,0.1);
}

.credit {
  padding: 15px;
  font-size: 16px;
}

.payment-method {
  padding: 20px;
  border-bottom: 1px solid rgba(0,0,0,0.1);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.payment-method-action-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  flex: 1;
  text-align: end;
}

.payment-method-default {
  padding: 3px 6px;
  margin: 2px 5px;
  height: max-content;
  background-color: #dedede;
  border-radius: 5px;
  letter-spacing: 1px;
  cursor: default;
  font-size: 10px;
  text-transform: uppercase;
  text-decoration: none;
  color: #555;
}

.payment-method-action-button {
  font-size: 12px;
  letter-spacing: 0.4px;
  text-decoration: underline;
  cursor: pointer;
  color: #6c6c6c;
  margin: 2px 5px;
}

.payment-method-delete { 
  color: var(--tambr-warn-color, #db0e09); 
  font-weight: 500;
}

.loading-overlay {
  position: absolute;
  background: #00000010;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  visibility: hidden;
}

.loading-overlay.open { visibility: visible; }

.no-payment-methods {
  padding: 50px 20px 10px;
  text-align: center;
}

.tambr-button { width: auto; }

.skeleton-card {
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 14px 50px;
  border-bottom: 1px solid rgba(0,0,0,0.1);
}

.skeleton-card .card-info { display: flex; flex-direction: column; }

.skeleton-card .card-info .skeleton-text.card-number { width: 150px; }

.skeleton-card .card-info .skeleton-text.card-expiry { width: 100px; height: 14px; }

.skeleton-card .card-actions .skeleton-text { width: 50px; }

.skeleton-card .card-actions .skeleton-text.red { 
  background-color: var(--tambr-warn-color, #db0e09);
}